import { render, staticRenderFns } from "./freebirdaktarim.vue?vue&type=template&id=1e846f9e"
import script from "./freebirdaktarim.vue?vue&type=script&lang=js"
export * from "./freebirdaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports